<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">My Monthly Overtime Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="search">
      <div class="row align-items-center mt-2">
        <div class="col-md-2">Approved Date From</div>
        <div class="col-md-4 pl-md-0">
          <input
            type="date"
            class="form-control"
            v-model="approvedDateFrom"
            required
          />
        </div>
        <div class="col-md-2 ml-md-4">Approved Date To</div>
        <div class="col-md-3 pl-md-0">
          <input
            type="date"
            class="form-control"
            v-model="approvedDateTo"
            required
          />
        </div>
      </div>

      <div class="row align-items-center mt-2">
        <div class="col-md-2">Timesheet Month / Year From</div>
        <div class="col-md-4 pl-md-0">
          <div class="row">
            <div class="col-md-6">
                <select class="custom-select" v-model="monthFrom" required>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                </select>
            </div>

            <div class="col-md-6">
                <select class="custom-select" v-model="yearFrom" required>
                    <option v-for="year in years" :key="year" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>
          </div>
        </div>

        <div class="col-md-2 ml-md-4">Timesheet Month / Year To</div>
        <div class="col-md-3 pl-md-0">
          <div class="row">
            <div class="col-md-6">
                <select class="custom-select" v-model="monthTo" required>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                </select>
            </div>

            <div class="col-md-6">
                <select class="custom-select" v-model="yearTo" required>
                    <option v-for="year in years" :key="year" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row align-items-center mt-2">
        <div class="col-md-2">Employee Name/ID</div>
        <div class="col-md-4 pl-md-0">
          <span>{{ employeeName + " (" + employeeID + ")" }}</span>
        </div>
        <div class="col-md-2 ml-md-4">
          <button type="submit" class="btn btn-primary">Search</button>
        </div>
      </div>
    </form>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4 align-items-center" v-if="records && records.length">
      <div class="col-md-6">
        
      </div>
      <div class="col-md-6 text-right">
        <form
          ref="form"
          :action="backendUrl + '/AttendanceExcelReport/ExportMonthlyOvertime'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="company" />
          <input type="hidden" name="Department" :value="department" />
          <input type="hidden" name="ApprovedDateFrom" :value="approvedDateFrom" />
          <input type="hidden" name="ApprovedDateTo" :value="approvedDateTo" />
          <input type="hidden" name="MonthFrom" :value="monthFrom" />
          <input type="hidden" name="MonthTo" :value="monthTo" />
          <input type="hidden" name="YearFrom" :value="yearFrom" />
          <input type="hidden" name="YearTo" :value="yearTo" />
          <input type="hidden" name="JobGrade" :value="jobGrade" />
          <input type="hidden" name="CostCentre" :value="costCentre" />
          <input type="hidden" name="ManagerID" :value="manager" />
          <input type="hidden" name="Designation" :value="designation" />
          <input type="hidden" name="EmployeeID" :value="userId" />
          <button type="button" @click="exportExcel" class="btn btn-sm btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>

    <!-- Result -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th colspan="2">Employee</th>
                <th rowspan="2">Designation</th>
                <th rowspan="2">Department</th>
                <th rowspan="2">Job Grade</th>
                <th rowspan="2">Cost Centre</th>
                <th rowspan="2">Date<br>Approved</th>
                <th rowspan="2">Timesheet<br>Month/Year</th>
                <template v-if="!isNewLayout">
                  <th colspan="2">No. of OT hrs Clocked<br>for (CATS)</th>
                  <th rowspan="2">Total OT Hours<br>(CATS)</th>
                  <th colspan="2">No. of OT hrs clocked<br>for (Boardroom)</th>
                  <th rowspan="2">Total OT Hours<br>(Boardroom)</th>
                </template>
                <template v-else>
                  <th rowspan="2">Imported OT Hours<br>(CATS)</th>
                  <th rowspan="2">Approved OT Hours<br>(Boardroom)</th>
                </template>
              </tr>
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <template v-if="!isNewLayout">
                  <th>Mon-Fri</th>
                  <th>Sun & PH</th>
                  <th>Mon-Fri</th>
                  <th>Sun & PH</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in records" :key="i">
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.Designation }}</td>
                <td>{{ item.Department }}</td>
                <td>{{ item.JobGrade }}</td>
                <td>{{ item.CostCentre }}</td>
                <td>{{ item.DateApprovedDisplay }}</td>
                <td>{{ item.MonthYear }}</td>
                <template v-if="!isNewLayout">
                  <td>{{ item.SumImportedMonSat }}</td>
                  <td>{{ item.SumImportedSunPH }}</td>
                  <td>{{ item.SumImportedMonSat + item.SumImportedSunPH }}</td>
                  <td>{{ item.SumApprovedMonSat }}</td>
                  <td>{{ item.SumApprovedSunPH }}</td>
                  <td>{{ item.SumApprovedMonSat + item.SumApprovedSunPH }}</td>
                </template>
                <template v-else>
                  <td>{{ item.SumImported }}</td>
                  <td>{{ item.SumApproved }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Result -->   
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Select2 from "v-select2-component";

export default {
  components: { Select2 },
  data() {
    let data = JSON.parse(localStorage.getItem("lambitoken"));

    let userId = "", employeeName = "", employeeID = "", managerID = "", managerName = "", managerEmployeeID = "";
    userId = data.Id;
    employeeName = data.Name;
    employeeID = data.EmployeeID;

    return {
      isNewLayout: false,
      companies: [],
      departments: [],
      costCentres: [],
      designations: [],
      jobGrades: [],
      managers: [],
      employees: [],
      company: data.Role != 'admin' ? data.Company : '',
      department: "",
      costCentre: "",
      designation: "",
      jobGrade: "",
      manager: managerID,
      selectedEmployees: [],
      userId: userId,
      approvedDateFrom: "",
      approvedDateTo: "",
      monthFrom: "",
      monthTo: "",
      yearFrom: "",
      yearTo: "",
      records: [],
      role: data.Role,
      employeeName: employeeName,
      employeeID: employeeID,
      managerName: managerName,
      managerEmployeeID: managerEmployeeID,




      years: [],
      types: [],
      categories: [],
      
      //search form
      
      year: "",
      typeId: "",
      categoryId: "",
      groupDental: "",
      groupHsmm: "",
      //for excel
      companyForExcel: "",
      yearForExcel: "",
      typeIdForExcel: "",
      categoryIdForExcel: "",
      groupDentalForExcel: "",
      groupHsmmForExcel: "",
      noRecordText: config.NO_RECORD_TEXT,
      //pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 5,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    employeeCompany() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Company;
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },

  watch: {
    typeId(val) {
      this.categoryId = "";
      if (!val) {
        this.categories = [];
        return;
      }
      let param = {
        Token: this.token,
        InsuranceTypeId: val,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMappingEnrolmentCategories(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.categories = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.search();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    getAttendanceReportSelection() {
        let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getAttendanceReportSelection(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.companies;
            this.costCentres = response.data.costCentres;
            this.departments = response.data.departments;
            this.designations = response.data.designations;
            this.jobGrades = response.data.jobGrades;
            this.managers = response.data.managers;
            this.employees = response.data.employees;
            this.employees.unshift({ id: "All", text: "All" });

            this.company = this.companies[0].CompanyName;  
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    
    getManagerEmployees() {
      let param = { Token: this.token, IsActive: true, ManagerID: this.manager };
      this.$store.state.isLoading = true;
      API.getManagerEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            this.employees.unshift({ id: "All", text: "All" });
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let param = { Token: this.token, IsActive: true };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //actual search
      let param = {
        Token: this.token,
        /*Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,*/
        Company: this.company,
        Department: this.department,
        ApprovedDateFrom: this.approvedDateFrom,
        ApprovedDateTo: this.approvedDateTo,
        MonthFrom: this.monthFrom,
        MonthTo: this.monthTo,
        YearFrom: this.yearFrom,
        YearTo: this.yearTo,
        JobGrade: this.jobGrade,
        CostCentre: this.costCentre,
        ManagerID: this.manager,
        Designation: this.designation,
        SelectedEmployeeID: []
      };

      if ( this.userId != "" && this.userId != "All" ) {
        param.SelectedEmployeeID.push(this.userId);
      }

      this.$store.state.isLoading = true;
      API.searchMonthlyOvertimeTimesheet(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            /*
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }*/
            let mixedLayoutMessage = response.data.mixedLayoutMessage;
            if (mixedLayoutMessage) {
              alert(mixedLayoutMessage);
              return;
            }
            if ( response.data.isEmpty ) {
              this.records = [];
            }
            else {
              this.isNewLayout = response.data.isNewLayout;
              this.records = response.data.record;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          // this.$swal(error.response.data.Message, { icon: "error" });
          this.records = [];
          console.log("error", error.response.data.Message);
        });
    },
    exportExcel(){
      let param = {
        Token: this.token,
        Company: this.company,
        MonthFrom: this.monthFrom,
        MonthTo: this.monthTo,
        YearFrom: this.yearFrom,
        YearTo: this.yearTo
      };
      API.checkMixedLayout(param)
        .then((response) => {
          if (response.data.success) {
            let mixedLayoutMessage = response.data.mixedLayoutMessage;
            if (mixedLayoutMessage) {
              alert(mixedLayoutMessage);
              return;
            } else {
              this.$refs.form.submit();
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.search();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.search();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.search();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.search();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.search();
    },
  },

  created() {
    if ( this.role == 'admin' ) this.getAttendanceReportSelection();

    this.getYears();
  },
};
</script>

<style scoped>
.col-md-2 {
  max-width: 185px;
}
th, td {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/MyMonthlyOvertimeReport.vue